import type * as ecModels from '../../../models'

export interface Config<TTypeParams extends ecModels.TypeParams.Constraint> {
  /**
   * The editing plugin allows the creation of new entities with partially or
   * completely undefined inputs. For collections where that is a problem, this
   * method can be used to convert a partially or completely undefined input
   * into a complete creation entity
   */
  newCreation?: (
    input: Partial<TTypeParams['createEntity']> | undefined,
  ) => TTypeParams['createEntity']
}
export namespace Config {
  export function from<TTypeParams extends ecModels.TypeParams.Constraint>(
    config: Config.Options<TTypeParams> | undefined,
  ): Config<TTypeParams> {
    return config ?? {}
  }

  export type Options<TTypeParams extends ecModels.TypeParams.Constraint> =
    Partial<Config<TTypeParams>>
}
